import { getClientNavigationLink } from '@/utils/post/utils';
import React from 'react';

interface RedirectLinkProps {
  to: string;
  children: React.ReactNode;
  replace?: boolean;
  className?: string;
  [key: string]: any;
}

const RedirectLink: React.FC<RedirectLinkProps> = ({
  to,
  children,
  replace = false,
  className,
  ...props
}: RedirectLinkProps) => {
  const [showPrefetch, setShowPrefetch] = React.useState(false);

  const handleNavigation = (event?: React.MouseEvent | React.KeyboardEvent) => {
    if (event) event.preventDefault();

    if (replace) {
      window.history?.replaceState({}, '', to);
    } else {
      window.history?.pushState({}, '', to);
    }

    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleNavigation(event);
    }
  };

  return (
    <>
      <div
        role="link"
        tabIndex={0}
        className={className}
        onClick={handleNavigation}
        onKeyDown={handleKeyDown}
        onMouseEnter={() => setShowPrefetch(true)}
        onMouseLeave={() => setShowPrefetch(false)}
        {...props}
      >
        {children}
      </div>
      {showPrefetch && <link rel="prefetch" href={getClientNavigationLink(to)} />}
    </>
  );
};

export default RedirectLink;
